export const ZIPWHIP = {
  id: 1,
  abbrev: 'ZW',
  requiresSegmentation: true,
  maxSmsMessageLength: 250,
  maxMmsMessageLength: 700,
  maxFileSizeKb: 592
};

export const BANDWIDTH = {
  id: 2,
  abbrev: 'BW',
  requiresSegmentation: false,
  maxSmsMessageLength: -1,
  maxMmsMessageLength: -1,
  maxFileSizeKb: 1024
};

export const ALL = [
  ZIPWHIP,
  BANDWIDTH
];
